/**
 * hebcal renders Hebrew with nikud; printed stationery does not use it.
 */
export const plain = (s: string) =>
  // U+05BE MAQAF is the Hebrew hyphen and sits inside the nikud block — keep it.
  s.normalize('NFD').replace(/[\u0591-\u05BD\u05BF-\u05C7]/g, '')

/** Everything the footer knows about the congregation. */
export type FooterShul = {
  name: string
  addressLine?: string | null
  city?: string | null
  region?: string | null
  postalCode?: string | null
  phone?: string | null
  email?: string | null
}

/** Where the congregation is, as one line. */
export function postalAddress(shul: Omit<FooterShul, 'name'>): string {
  return postalLines(shul).join(', ')
}

/** The same address as the lines an envelope sets it on. */
export function postalLines(shul: Omit<FooterShul, 'name'>): string[] {
  return [
    shul.addressLine,
    [shul.city, shul.region, shul.postalCode].filter(Boolean).join(' '),
  ].filter((part): part is string => Boolean(part?.trim()))
}

/** The place and contact halves of the stationery's foot. */
export function footerParts(shul: FooterShul): {
  place: string
  contact: string
} {
  const address = postalAddress(shul)
  return {
    place: [shul.name, address].filter(Boolean).join(' • '),
    contact: [shul.phone, shul.email].filter(Boolean).join(' • '),
  }
}

/** Both halves on one line — what a sheet with no room for a second prints. */
export function footerLine(shul: FooterShul): string {
  const { place, contact } = footerParts(shul)
  return [place, contact].filter(Boolean).join(' • ')
}
